import React from "react";
import { useTranslation } from "react-i18next";

import { FILE_UPLOAD } from "../../constants/global.constants";
import { getSupportedFileTypes } from "../../utils/appUtils";
import DupontButton from "../DupontButton";
import { downloadIcon } from "../../assets";

const SupportedFileInfo = () => {
  const { t } = useTranslation();
  
  const file_name = FILE_UPLOAD.CIP_BULK_UPLOAD_TEMPLATE;
  const path = `assets/${file_name}`;
  const downloadXLSX = () => {
    // Create a link element to trigger the download
    const a = document.createElement("a");
    a.href = path;
    a.download = file_name;
    // Trigger a click event on the link to start the download
    a.click();
  };

  return (
    <div className="supported-file-info">
      <p className="type">
        {getSupportedFileTypes(FILE_UPLOAD.SUPPORTED_FILE_TYPES)}{" "}
        {t("fileUpload.allowed")}
      </p>

      
      <DupontButton
        type="tertiary"
        customClass="download-button-cip-template"
        onClick={downloadXLSX}
      >
        <img src={downloadIcon} alt="download" className="download-icon" />
        {t("ValueStrings.downloadTemplate")}
      </DupontButton>
      <p className="size">
        {t("fileUpload.maxSize")} {FILE_UPLOAD.MAX_FILE_SIZE}
      </p>
    </div>
  );
};

export default SupportedFileInfo;
